import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import CheckoutButton from "../checkout/CheckoutButton";

const InscriptionModalEbook = ({ show, handleClose, ebook, newPrice, currency, country }) => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // Estado para el loading
  const [paymentMethod, setPaymentMethod] = useState(""); // Estado para el método de pago

  // Esta función ahora solo se usa para pagos manuales (transferencias)
  const handleSubmit = async () => {

    setLoading(true); // Activar el estado de carga

    localStorage.setItem("ebookData", JSON.stringify({
      student: formData,
      ebook_name: ebook.title,
      ebook_price: newPrice,
      ebook_currency: currency,
      ebook_id: ebook.id,
      send_inscription: true
    }));

    try {
      // Crear un objeto FormData
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const apiUrl = `${process.env.REACT_APP_HOST_BACKEND}/send_ebook`;

      const response = await fetch(apiUrl, {
        method: "POST",
        body: formDataToSend,
        mode: 'cors'
      });

      const result = await response.json();

      if (result.status === "success") {
        handleClose(); // Cerrar el modal después de enviar
        navigate('/success-ebook'); // Redirigir a la página de éxito
      } else {
        handleClose(); // Cerrar el modal después de enviar
        navigate('/rejected'); // Redirigir a la página de rechazo
      }
    } catch (error) {
      alert("Hubo un problema al generar la compra del Ebook.");
    } finally {
      setLoading(false); // Desactivar el estado de carga
    }
  };

  const [formData, setFormData] = useState({
    fullName: "",
  //  identificationDocument: "",
    email: "",
 //   age: "",
 //   gender: "",
    phone: "",
    country: "",
    paymentProof: null,
    nameHolder: "",
    emailHolder: "",
  });

  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [showPaymentProof, setShowPaymentProof] = useState(false);
  const [showPaymentInfo, setShowPaymentInfo] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
    // Si eligen pasarela, nos aseguramos de que no se muestre el campo para subir archivo
    if (method === 'gateway') {
      setShowPaymentProof(false);
    } else {
      setShowPaymentProof(true);
    }
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      paymentProof: e.target.files[0],
    }));
  };

  const handleCountryChange = (e) => {
    const country = e.target.value;
    setFormData((prev) => ({ ...prev, country }));

    setShowPaymentDetails(country !== "");
    // Por defecto, al cambiar de país, reseteamos el método de pago
    setPaymentMethod("");

    if (country === "VE") {
      setShowPaymentInfo("ve");
      setShowPaymentProof(true);
    } else if (country === "CO") {
      setShowPaymentInfo("co");
      // En Colombia, no mostramos el campo de comprobante de pago hasta que elijan "transferencia"
      setShowPaymentProof(false);
    } else {
      setShowPaymentInfo(country);
      setShowPaymentProof(false);
    }
  };

  // Condición para saber si se debe mostrar la pasarela de pago
  const isCardPayment = (showPaymentInfo !== "ve" && showPaymentInfo !== "co" && showPaymentInfo !== "") || (showPaymentInfo === "co" && paymentMethod === "gateway");

  // Verificar si todos los campos están completos
  const isFormComplete =
    formData.fullName &&
  //  formData.identificationDocument &&
    formData.email &&
  //  formData.age &&
  //  formData.gender &&
    formData.phone &&
    formData.country &&
    (!showPaymentProof || formData.paymentProof) && // Si se requiere el comprobante, debe estar adjunto.
    (!isCardPayment && (showPaymentProof) || (
      formData.nameHolder &&
      formData.emailHolder
    ));

  const items = [
    {
      id: ebook?.id,
      title: ebook?.title || "Ebook",
      price: newPrice,
      quantity: 1,
      currency: currency === "$" ? "USD" : currency,
      country: country,
    },
  ];

  const totalCost = `${(newPrice ?? 0).toLocaleString("de-DE")} ${currency}`;

  return (
    <Modal show={show} onHide={handleClose} centered className="custom-modal">
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title>Formulario de Descarga Ebook</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && (
          <div className="loading-spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <Form encType="multipart/form-data">
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control type="text" name="fullName" onChange={handleInputChange} required />
          </Form.Group>
{/*
          <Form.Group className="mb-3">
            <Form.Label>Número de Identificación</Form.Label>
            <Form.Control type="text" name="identificationDocument" onChange={handleInputChange} required />
          </Form.Group>
 */ }
          <Form.Group className="mb-3">
            <Form.Label>Correo Electrónico</Form.Label>
            <Form.Control type="email" name="email" onChange={handleInputChange} required />
          </Form.Group>
{/*
          <Row className="mb-3">
            <Col>
              <Form.Group>
                <Form.Label>Edad</Form.Label>
                <Form.Control type="number" name="age" onChange={handleInputChange} required />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Sexo</Form.Label>
                <Form.Select className="form-control" name="gender" onChange={handleInputChange} required>
                  <option value="">Selecciona</option>
                  <option value="Masculino">Masculino</option>
                  <option value="Femenino">Femenino</option>
                  <option value="Otro">Otro</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
*/}
          <Form.Group className="mb-3">
            <Form.Label>Número de Celular</Form.Label>
            <Form.Control type="tel" name="phone" onChange={handleInputChange} required />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>País de Residencia</Form.Label>
            <Form.Select className="form-control" name="country" onChange={handleCountryChange} required>
              <option value="">Selecciona un país</option>
              <option value="VE">Venezuela</option>
              <option value="CO">Colombia</option>
              <option value="CL">Chile</option>
              <option value="PE">Peru</option>
              <option value="US">Estados Unidos</option>
              <option value="MX">México</option>
              <option value="ES">España</option>
              <option value="AR">Argentina</option>
              <option value="other">Otro</option>
            </Form.Select>
          </Form.Group>

          {showPaymentInfo === "co" && (
            <Alert variant="info">
              <strong>Elige tu método de pago:</strong>
              <div className="d-flex gap-3 mt-2">
                <Button
                  variant={paymentMethod === "transfer" ? "primary" : "outline-primary"}
                  onClick={() => handlePaymentMethodChange("transfer")}
                >
                  Pago por transferencia
                </Button>
                <Button
                  variant={paymentMethod === "gateway" ? "primary" : "outline-primary"}
                  onClick={() => handlePaymentMethodChange("gateway")}
                >
                  Pago con pasarela
                </Button>
              </div>
            </Alert>
          )}

          {/* Datos de pago para Venezuela */}
          {showPaymentInfo === "ve" && (
            <Alert variant="info">
              <strong>Pago Móvil</strong>
              <br />
              <strong>Banco:</strong> Provincial <br />
              <strong>Cédula:</strong> 19241582 <br />
              <strong>Celular:</strong> 0416-3574963
              <Form.Group className="mt-2">
                <Form.Label>Comprobante de Pago</Form.Label>
                <Form.Control type="file" accept="image/*" name="paymentProof" onChange={handleFileChange} required />
                <Form.Text className="text-muted">
                  Adjunta una imagen del comprobante en formato JPG o PNG.
                </Form.Text>
              </Form.Group>
            </Alert>
          )}

          {/* Datos de pago para Colombia */}
          {(showPaymentInfo === "co" && paymentMethod === "transfer") && (
            <Alert variant="info">
              <strong>Datos de Pago:</strong> <br />
              <strong>Bancolombia - Cuenta de Ahorros:</strong> 00689258018 <br />
              <strong>Nequi:</strong> 3177169274 <br />
              <Form.Group className="mt-2">
                <Form.Label>Comprobante de Pago</Form.Label>
                <Form.Control type="file" accept="image/*" name="paymentProof" onChange={handleFileChange} required />
                <Form.Text className="text-muted">
                  Adjunta una imagen del comprobante en formato JPG o PNG.
                </Form.Text>
              </Form.Group>
            </Alert>
          )}

          {((showPaymentInfo !== "ve" && showPaymentInfo !== "co" && showPaymentInfo !== "") || (showPaymentInfo === "co" && paymentMethod === "gateway")) && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>Nombre del pagador</Form.Label>
                <Form.Control type="text" placeholder="Tal como aparece en su tarjeta" name="nameHolder" onChange={handleInputChange} required />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Correo del pagador</Form.Label>
                <Form.Control type="text" name="emailHolder" onChange={handleInputChange} required />
              </Form.Group>
            </>
          )}

          <div class="payment-box">
            <div class="payment-header">
              <span>Total a Pagar</span>
            </div>
            <div class="payment-amount">
              <span id="totalAmount">{totalCost}</span>
            </div>
            <h6 style={{color: 'white'}}>Pago 100% Seguro</h6>
          </div>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose} disabled={loading}>Cerrar</Button>
            {/* Si es pago con pasarela, muestra CheckoutButton. Si no, muestra el botón de compra manual. */}
            {isCardPayment ? (
              <CheckoutButton items={items} formData={formData} disabled={!isFormComplete} type={2} /* El tipo 2 es para Ebook*/ />
            ) : (
              <Button variant="primary" disabled={!isFormComplete || loading} onClick={handleSubmit}>
                {loading ? "Enviando..." : "Procesar Pago"}
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default InscriptionModalEbook;
